<template>
  <el-col :span="24">
    <template v-for="(form, idx) in forms">
      <el-form-item
        size="small"
        v-if="idx >= 0 && idx <= 2"
        :key="form.label"
        :prop="form.id"
        :label="form.label"
        :rules="form.rules"
      >
        <el-input
          v-if="form.type == 'text' || form.type == 'number'"
          :disabled="form.disable"
          v-model="Banner[form.id]"
          :type="form.type"
          :placeholder="`Please input ${form.label}`"
        ></el-input>
        <el-input
          v-else-if="form.type == 'textarea'"
          type="textarea"
          :disabled="form.disable"
          :rows="2"
          :placeholder="`Please input ${form.label}`"
          v-model="Banner[form.id]"
        ></el-input>
        <el-select
          v-else-if="form.type == 'select'"
          v-model="Banner[form.id]"
          style="width: 100%"
          filterable
          remote
          :remote-method="form.onSearch"
        >
          <el-option
            v-for="item in form.data"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </template>

    <el-form-item
      v-if="Banner['bannerType'] === 'promo'"
      size="small"
      :prop="forms[3].id"
      :label="forms[3].label"
      :rules="forms[3].rules"
    >
      <el-select
        v-model="Banner[forms[3].id]"
        style="width: 100%"
        filterable
        remote
        :remote-method="forms[3].onSearch"
        :loading="forms[3].onLoading"
      >
        <el-option
          v-for="item in forms[3].data"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        ></el-option>
        <el-row v-if="forms[3].loadMore" type="flex" justify="center">
          <el-button
            :loading="forms[3].onLoading"
            size="mini"
            round
            @click="forms[3].loadMore"
          >Load More</el-button>
        </el-row>
      </el-select>
    </el-form-item>

    <el-form-item size="small" prop="picture" label="Picture">
      <el-row>
        <el-image style="width: 100%; height: 260px" :src="Banner.photoUrl" fit="contain"></el-image>
        <input
          style="display: none"
          type="file"
          placeholder="Please Input Payment Note"
          ref="fileInputPicture"
          accept="image/*"
          @change="e => onFilePicked(e, 'picture')"
        />

        <el-row type="flex" justify="center" class="mt-2">
          <el-col :span="12">
            <el-button
              type="primary"
              size="small"
              @click="onPickFile('picture')"
              style="width: 100%"
              :loading="loadingUploadBanner"
            >Upload</el-button>
          </el-col>
        </el-row>
      </el-row>
    </el-form-item>
  </el-col>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ApiService from "../../common/api.service";
export default {
  props: ["Banner", "from"],
  data() {
    return {
      limitPromo: 25,
      loadingUploadBanner: false
    };
  },
  computed: {
    ...mapState({
      promos: state => state.promo.promos
    }),
    forms() {
      return [
        {
          type: "text",
          id: "name",
          label: "Name",
          rules: [
            { required: true, message: "Name is required", trigger: "blur" }
          ],
          disable: false
        },
        {
          type: "textarea",
          id: "description",
          label: "Description",
          rules: [
            {
              required: true,
              message: "Description is required",
              trigger: "blur"
            }
          ],
          disable: false
        },
        {
          type: "select",
          id: "bannerType",
          label: "Banner Type",
          rules: [
            {
              required: true,
              message: "Banner Type is required",
              trigger: "blur"
            }
          ],
          data: [
            {
              name: "Information",
              value: "information"
            },
            {
              name: "Promo",
              value: "promo"
            }
          ],
          onSearch: null,
          onLoading: null,
          disable: false
        },
        {
          type: "select",
          id: "promo",
          label: "Promo ID",
          rules: [],
          data: this.promos.data.map(item => {
            item.name = `${item.promoId} - ${item.title}`;
            item.value = item.promoId;
            return item;
          }),
          loadMore: this.loadMorePromo,
          onSearch: this.onSearchPromo,
          onLoading: this.promos.isLoading,
          disable: false
        }
      ];
    }
  },
  methods: {
    ...mapActions({
      getPromo: "promo/GetPromos"
    }),
    onSearchPromo(search) {
      let option = {
        params: {
          page: 1,
          limit: 25,
          search: search
        }
      };
      this.getPromo(option);
    },
    loadMorePromo() {
      this.limitPromo += 25;
      let option = {
        params: {
          page: 1,
          limit: this.limitPromo
        }
      };
      this.getPromo(option);
    },
    onPickFile() {
      this.$refs.fileInputPicture.click();
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    async onFilePicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Please add a valid file!");
      }
      const fileReader = new FileReader();
      const body = {
        file: {
          base64: await this.toBase64(files[0])
        }
      };

      ApiService.init("heroku");
      this.loadingUploadBanner = true;
      const file = await ApiService.post("/v1/upload/banner", body); // perlu disesuaikan dengan relative url yang di-deploy
      this.loadingUploadBanner = false;
      fileReader.addEventListener("load", () => {
        this.Banner.photoUrl = file.data.data.location;
      });
      fileReader.readAsDataURL(files[0]);
    }
  },
  created() {
    let option = {
      params: {
        page: 1,
        limit: 25
      }
    };
    this.getPromo(option);
  }
};
</script>

<style></style>
